import { render, staticRenderFns } from "./paperEditQuestion.vue?vue&type=template&id=2524178d&"
import script from "./paperEditQuestion.vue?vue&type=script&lang=js&"
export * from "./paperEditQuestion.vue?vue&type=script&lang=js&"
import style0 from "./paperEditQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports